const baseURL = 'https://demoropa.solutiontechvp.com/';

export default baseURL;
